import PropTypes from 'prop-types';
import React, { createContext, useCallback, useContext, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import {
  BREAKPOINTS,
  SESSION_STORAGE_FILTERS_OPEN,
  TRUE_STRING,
} from '@/common/constants';

const ProductsFiltersContext = createContext(null);

export const ProductsFiltersContextProvider = ({ children }) => {
  const isMinDesktop = useMediaQuery({ minWidth: BREAKPOINTS.desktop });
  const hasValue =
    sessionStorage.getItem(SESSION_STORAGE_FILTERS_OPEN) !== null;
  const savedValue =
    sessionStorage.getItem(SESSION_STORAGE_FILTERS_OPEN) === TRUE_STRING;

  const [filtersOpen, setFiltersOpen] = useState(
    hasValue ? savedValue : isMinDesktop,
  );

  const setFiltersOpenHandler = useCallback((value) => {
    sessionStorage.setItem(SESSION_STORAGE_FILTERS_OPEN, value);
    setFiltersOpen(value);
  }, []);

  return (
    <ProductsFiltersContext.Provider
      value={{ filtersOpen, setFiltersOpen: setFiltersOpenHandler }}
    >
      {children}
    </ProductsFiltersContext.Provider>
  );
};

export const useProductsFilters = () => useContext(ProductsFiltersContext);

ProductsFiltersContextProvider.defaultProps = {};

ProductsFiltersContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
